import { SettingsNew } from './SettingsNew'

export const Settings = () => {
    return <SettingsNew />
}
